<template>
    <div>
        <template v-if="!componentIsLoading">
            <h5>Adresse des documents sociaux</h5>

            <errors :items="errors"
                @errors-closed="resetErrors"
            ></errors>

            <form v-if="fields.length > 0">
                <div class="form-group">
                    <label>{{ getField('social_address.same_as_existing_address').label }}</label>

                    <custom-select :field="getField('social_address.same_as_existing_address')" 
                        :value="socialCertificate.social_address.same_as_existing_address"
                        :field_idx="'social_address.same_as_existing_address'"
                        @field-updated="$emit('field-updated', $event)">
                    </custom-select>
                </div>

                <div v-show="'other' == socialCertificate.social_address.same_as_existing_address">
                    <div class="form-group">
                        <label>{{ getField('social_address.corporation_name').label }}</label>

                        <custom-text :field="getField('social_address.corporation_name')" 
                            :value="socialCertificate.social_address.corporation_name" 
                            :field_idx="'social_address.corporation_name'"
                            @field-updated="$emit('field-updated', $event)">
                        </custom-text>
                    </div>

                    <div class="form-group">
                        <label>{{ getField('social_address.first_name').label }}</label>

                        <custom-text :field="getField('social_address.first_name')" 
                            :value="socialCertificate.social_address.first_name" 
                            :field_idx="'social_address.first_name'"
                            @field-updated="$emit('field-updated', $event)">
                        </custom-text>
                    </div>
                    
                    <div class="form-group">
                        <label>{{ getField('social_address.last_name').label }}</label>

                        <custom-text :field="getField('social_address.last_name')" 
                            :value="socialCertificate.social_address.last_name" 
                            :field_idx="'social_address.last_name'"
                            @field-updated="$emit('field-updated', $event)">
                        </custom-text>
                    </div>

                    <div class="form-group">
                        <label>{{ getField('social_address.street_line1').label }}</label>

                        <custom-text :field="getField('social_address.street_line1')" 
                            :value="socialCertificate.social_address.street_line1" 
                            :field_idx="'social_address.street_line1'"
                            @field-updated="$emit('field-updated', $event)">
                        </custom-text>
                    </div>

                    <div class="form-group">
                        <label>{{ getField('social_address.street_line2').label }}</label>

                        <custom-text :field="getField('social_address.street_line2')" 
                            :value="socialCertificate.social_address.street_line2" 
                            :field_idx="'social_address.street_line2'"
                            @field-updated="$emit('field-updated', $event)">
                        </custom-text>
                    </div>

                    <div class="form-group">
                        <label>{{ getField('social_address.zipcode').label }}</label>

                        <custom-text :field="getField('social_address.zipcode')" 
                            :value="socialCertificate.social_address.zipcode" 
                            :field_idx="'social_address.zipcode'"
                            @field-updated="$emit('field-updated', $event)">
                        </custom-text>
                    </div>

                    <div class="form-group">
                        <label>{{ getField('social_address.city').label }}</label>

                        <custom-text :field="getField('social_address.city')" 
                            :value="socialCertificate.social_address.city" 
                            :field_idx="'social_address.city'"
                            @field-updated="$emit('field-updated', $event)">
                        </custom-text>
                    </div>

                    <div class="form-group" v-if="'US' == socialCertificate.social_address.country">
                        <label>{{ getField('social_address.state').label }}</label>

                        <custom-select :field="getField('social_address.state')" 
                            :value="socialCertificate.social_address.state"
                            :field_idx="'social_address.state'"
                            @field-updated="$emit('field-updated', $event)">
                        </custom-select>
                    </div>
                    
                    <div class="form-group">
                        <label>{{ getField('social_address.country').label }}</label>

                        <custom-select :field="getField('social_address.country')" 
                            :value="socialCertificate.social_address.country"
                            :field_idx="'social_address.country'"
                            @field-updated="$emit('field-updated', $event)">
                        </custom-select>
                    </div>
                </div>
            </form>

            <div class="buttons clearfix">
                <button class="btn btn-default btn-sm"
                    @click="$emit('current-step-changed', 'accounting-address')"
                >
                    Précédent
                </button>
                
                <button class="btn btn-success btn-sm pull-right"
                    @click="validateCurrentStep"
                >
                    Suivant
                </button>
            </div>
        </template>

        <component-loader v-else></component-loader>
    </div>
</template>

<script>
    import api from 'store/api'
    import formStepMixin from "mixins/socialCertificateFormStep";
    import Errors from './Errors'
    import CustomSelect from "components/Forms/Elements/Select"
    import CustomText from "components/Forms/Elements/Text"
    import ComponentLoader from 'components/ComponentLoader'

    export default {
        mixins: [
            formStepMixin
        ],
        
        components: {
            Errors,
            CustomSelect,
            CustomText,
            ComponentLoader
        },

        props: {
            socialCertificate: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                componentIsLoading: false,
                fields: [],
            }
        },

        created() {
            this.componentIsLoading = true

            api.getCustomerSocialCertificateEditionSchema(this.profile.id, 'social_address')
                .then((response) => {
                    if (response.data.schema && response.data.schema.hasOwnProperty('fields')) {
                        this.fields = response.data.schema.fields
                    }

                    this.componentIsLoading = false
                })
        },

        methods: {
            validateCurrentStep() {
                if (this.validateAddressStep('social')) {
                    this.$emit('current-step-changed', 'customer-employees')
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/SocialCertificate/EditionForm/SocialAddressStep.vue